import i18next from 'i18next';
import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class QueueObservabilityIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchOverview() {
        try {
            return await this.service.getOverview();
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async retryFailed(queueName, limit = 100) {
        try {
            const response = await this.service.retryFailed(queueName, limit);
            toast.success(i18next.t('integrationToasts:failedJobsRequeued', { defaultValue: 'Failed jobs requeued' }));
            return response;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async drain(queueName) {
        try {
            const response = await this.service.drain(queueName);
            toast.success(i18next.t('integrationToasts:queueCleared', { defaultValue: 'Queue cleared' }));
            return response;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async removeJob(jobId) {
        try {
            const response = await this.service.removeJob(jobId);
            toast.success(i18next.t('integrationToasts:jobDeleted', { defaultValue: 'Job deleted' }));
            return response;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async fetchTrace(correlationId) {
        try {
            const response = await this.service.getTrace(correlationId);
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async enqueueHeavyTask(payload = {}) {
        try {
            const response = await this.service.enqueueHeavyTask(payload);
            toast.success(i18next.t('integrationToasts:heavyJobAddedToQueue', { defaultValue: 'Heavy job added to queue' }));
            return response;
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
